import { ListarClientesVendaServices } from "../../../Services/Cobranca/Proponentes/ProponentesServices";
import { Controller } from "../../Controller";

export function ListarClientesVendaController(idChaveErp: string | undefined) {
    return Controller(ListarClientesVendaServices(idChaveErp));
}
